import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectOnboarding } from 'services/auth/selectors'
import { selectStagedUser } from 'services/auth/selectors'
import { selectLoggedIn } from 'services/user/selectors'
import { selectQuery } from 'services/routing/selectors'
import { selectDev } from 'services/site/selectors'
import {
  selectConsentContent,
  selectConsentScreen,
} from 'services/consents/selectors'
import { selectAppConfig } from 'services/bootup/selectors'
import { withRouter } from 'react-router'
import * as consentActions from 'services/consents/actions'
import TermsOfService from './terms-of-service'
import ConsentRequired from './consents-required'
import CountryConfirmation from './country'
import isEmpty from 'lodash.isempty'
import { signupUser } from 'services/auth/actions'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { Loader } from 'components/util'
import styles from './_consents.css'
import { goToNext } from 'shared/routes'
import { SubmissionError } from 'redux-form'
import { injectIntl } from 'react-intl'
import messages from '../messages'

const mapStateToProps = (state) => ({
  appConfig: selectAppConfig(state),
  stagedUser: selectStagedUser(state),
  onboarding: selectOnboarding(state),
  isLoggedIn: selectLoggedIn(state),
  isDev: selectDev(state),
  consent: selectConsentContent(state),
  screen: selectConsentScreen(state),
  query: selectQuery(state),
})

const mapDispatchToActions = {
  ...consentActions,
  signupUser,
}

export class ConsentsPage extends Component {

  static propTypes = {
    appConfig: PropTypes.object,
    intl: PropTypes.object,
    isDev: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    stagedUser: PropTypes.object,
    onboarding: PropTypes.string,
    consent: PropTypes.object,
    query: PropTypes.object,
    fetchConsentStatus: PropTypes.func,
    screen: PropTypes.string,
    signupUser: PropTypes.func,
    location: PropTypes.object,
    updateConsents: PropTypes.func,
  }

  state = {
    submitting: false,
  }

  componentWillMount () {
    if (this.isNewUser()) {
      const { gdpr_iso_code } = this.props.stagedUser
      this.setState({ submitting: true })
      this.props.fetchConsentStatus(gdpr_iso_code)
      .then(() => {
        this.setState({ submitting: false })
      })
    }
  }

  onCreateAccountSuccess = () => {
    const { newUserOnboarding } = this.props.appConfig
    const { next } = this.props.query
    goToNext(next, newUserOnboarding)
  }

  handleSignupUser = (values) => {
    // Return error if all consents are not checked.
    if (!this.checkAllConsentsAccepted(values)) {
      return this.consentsRequiredError()
    }
    const userData = { ...this.props.stagedUser, ...values }
    this.setState({ submitting: true })
    return this.props.signupUser(this.props.onboarding, userData, false)
      .then(this.onCreateAccountSuccess)
      .catch((err) => {
        this.setState({ submitting: false })
        throw new SubmissionError({ _error: err.response.data.error })
      })
  }

  handleUpdateConsents = (newConsents) => {
    const { consent } = this.props
    // Return error if all consents are not checked.
    if (!this.checkAllConsentsAccepted(newConsents)) {
      return this.consentsRequiredError()
    }

    // Making sure `TOS` or `Other Consents` not overriden if not passed
    const { accepted: { tos, required }} = consent
    const consentsArray = [...tos, ...required]
    consentsArray.forEach((term) => {
      newConsents[term] = true
    })
    this.setState({ submitting: true })
    return this.props.updateConsents(consent.consentMatrixVersion, consent.gdprIsoCode, newConsents)
      .then(() => {
        this.setState({ submitting: false })
        window.location.reload(true)
      })
      .catch((err) => {
        this.setState({ submitting: false })
        throw new SubmissionError({ _error: err.response.data.error })
      })
  }

  checkAllConsentsAccepted (newConsents) {
    const { consent } = this.props
    // Check if all consents are checked.
    return consent.requiredContent.every((content) => {
      return newConsents[content.id]
    })
  }

  consentsRequiredError () {
    return Promise.reject().catch(() => {
      throw new SubmissionError({ _error: this.props.intl.formatMessage(messages.consentsAcceptAll) })
    })
  }

  isNewUser = () => {
    return !isEmpty(this.props.stagedUser)
  }

  render () {
    const {
      screen,
      consent,
    } = this.props

    const { submitting } = this.state
    return (
      <div>
        <ReactCSSTransitionGroup
          component='div'
          transitionName='fade'
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {submitting ?
            <div key='loader'>
              <div className={styles.loader}>
                <Loader height={60} width={60} />
              </div>
            </div>
        : null}
        </ReactCSSTransitionGroup>
        { screen === 'TERMS_OF_SERVICE' ? <TermsOfService tosContent={ consent.tosContent }
          consentMatrixVersion={consent.consentMatrixVersion} gdprIsoCode={consent.gdprIsoCode} /> : null }
        { screen === 'CONSENTS_REQUIRED' ? <ConsentRequired
          consentlist={ consent.requiredContent }
          onSubmit={ this.isNewUser() ? this.handleSignupUser : this.handleUpdateConsents }
          isNewUser={ this.isNewUser() } /> : null }
        { screen === 'COUNTRY_CONFIRMATION' ? <CountryConfirmation /> : null }
      </div>
    )
  }
}

export const IntlPage = injectIntl(ConsentsPage)
export default connect(mapStateToProps, mapDispatchToActions)(withRouter(IntlPage))
